/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Ai_Tools_BreadcrumbInputs */

const en_directory_ai_tools_breadcrumb = /** @type {(inputs: Directory_Ai_Tools_BreadcrumbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tools`)
};

const zh_directory_ai_tools_breadcrumb = /** @type {(inputs: Directory_Ai_Tools_BreadcrumbInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`工具`)
};

/**
* | output |
* | --- |
* | "Tools" |
*
* @param {Directory_Ai_Tools_BreadcrumbInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_ai_tools_breadcrumb = /** @type {((inputs?: Directory_Ai_Tools_BreadcrumbInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Ai_Tools_BreadcrumbInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_ai_tools_breadcrumb(inputs)
	return zh_directory_ai_tools_breadcrumb(inputs)
});
export { directory_ai_tools_breadcrumb as "directory.ai_tools.breadcrumb" }